function chinaPIPLTermsCssClasses(survey, options) {
  if('china-pipl-terms' === options.question.getType()) {
    options.cssClasses.mainRoot = `${options.cssClasses.root} china-pipl-terms`;
  }
}

export const ChinaPIPLTerms = {
  name: 'china-pipl-terms',
  title: 'China PIPL terms',
  elementsJSON: [
    {
      type: 'boolean',
      name: 'pipl1',
      title: '本人知悉且同意 NVIDIA 基于调研、活动组织的目的对本人的上述信息的收集和处理，并已经阅读并同意 <a href="https://www.nvidia.cn/about-nvidia/privacy-policy/" target="_blank">NVIDIA 隐私政策</a>。',
      isRequired: true,
      defaultValue: false,
      validators: [
        {
          type: 'expression',
          text: "确认同意上述条款之后，您才可以提交表单。",
          expression: '{china-pipl-terms.pipl1} = true',
        }
      ]
    }
  ],
  onLoaded({survey}) {
    if (survey) {
      survey.onUpdateQuestionCssClasses.add(chinaPIPLTermsCssClasses);
    }
  }
}
